module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "isShowMask": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "v5-checklist-selected-wrap"
  }, [_c('div', {
    staticClass: "v5-checklist-selected"
  }, [_c('span', {
    staticClass: "v5-checklist-selected-title"
  }, [_vm._v("已选")]), _vm._v(" "), _c('div', {
    staticClass: "v5-checklist-selected-scroller-wrap"
  }, [_c('scroller', {
    attrs: {
      "scrollingX": true,
      "scrollingY": false,
      "positionX": _vm.positionX
    }
  }, [_c('div', {
    staticClass: "v5-checklist-selected-list"
  }, _vm._l((_vm.currentValue), function(item) {
    return _c('a', {
      key: item.id,
      staticClass: "v5-checklist-selected-item",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.remove(item.id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t"), _c('i', {
      staticClass: "v5-checklist-selected-item-close"
    })])
  }), 0)])], 1)]), _vm._v(" "), _c('a', {
    staticClass: "v5-checklist-selected-btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确认 " + _vm._s(_vm.selLength) + "/" + _vm._s(_vm.max))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e93d7ea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@58fe/v5/src/components/checklist/selected/index.vue
// module id = 367
// module chunks = 0